import React, { useEffect, useState } from 'react';
import ErrorBanner from '../ErrorBanner/ErrorBanner';

interface CountdownProps {
  tiempoExpiracion: number;
  titulo?: string;
  mensaje: string;
  severity?: 'error' | 'info' | 'warning';
}

const Countdown = ({ tiempoExpiracion, titulo, mensaje, severity = 'info' }: CountdownProps) => {
  const [timeLeft, setTimeLeft] = useState(tiempoExpiracion - new Date().getTime());

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = new Date().getTime();
      const remainingTime = tiempoExpiracion - currentTime;

      if (remainingTime <= 0) {
        clearInterval(intervalId);
        setTimeLeft(0); // Expirado
      } else {
        setTimeLeft(remainingTime);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [tiempoExpiracion]);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60000);
    const seconds = Math.floor((time % 60000) / 1000);
    return `${minutes}m ${seconds}s`;
  };

  const quedaTiempo = timeLeft > 0;

  return (
    <ErrorBanner
      titulo={quedaTiempo ? titulo : 'Tiempo Expirado'}
      severity={quedaTiempo ? severity : 'error'}
      mensaje={`${quedaTiempo ? `${mensaje} - Tiempo restante: ${formatTime(timeLeft)}` : 'El tiempo para hacer la compra ha expirado. Intenta hacer la compra nuevamente.'}`}
    />
  );
};

export default Countdown;
